import { GridColDef } from "@mui/x-data-grid-premium";
import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useTranslate } from "src/locales";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import WaterLowExampleRows from "../model";
import WaterlowScore from "../create";
import ByzMuiEditButton from "src/components/core-components/mui/buttons/ByzMuiEditButton";
import BaseMedCardList from "src/components/shared-components/medcard/BaseMedCardList";
//YATAY;446221;18032025

const columns: GridColDef[] = [
  { field: "date", headerName: "Tarih", flex: 1 },
  { field: "field1", headerName: "Alan 1", flex: 1 },
  { field: "field2", headerName: "Alan 2", flex: 1 },
  { field: "field3", headerName: "Alan 3", flex: 1 },
  { field: "field4", headerName: "Alan 4", flex: 1 },
  { field: "field5", headerName: "Alan 5", flex: 1 },
  {
    field: "update",
    headerName: "Güncelle",
    width: 150,
    renderCell(params) {
      return <ByzMuiEditButton link={`edit/${params.row.id}`} />;
    },
  },
  {
    field: "delete",
    headerName: "Sil",
    flex: 1,
    renderCell: (params) => (
      <IconButton onClick={() => console.log(params.row.id)}>
        <DeleteIcon color="error" />
      </IconButton>
    ),
  },
];


function WaterlowScoreList() {
  const { t } = useTranslate();

  return (
    <BaseMedCardList
      title={t("waterlow-score.title")}
      CreateComponent={WaterlowScore}
      columns={columns}
      rows={WaterLowExampleRows}
    >
      <ByzMuiTypography
        sx={{
          fontSize: 13,
          fontWeight: 400,
          whiteSpace: "pre-line",
          wordWrap: "break-word",
          margin: 0,
          textAlign: "left",
        }}
      >
        {t("waterlow-score.list-info")}
      </ByzMuiTypography>
    </BaseMedCardList>
  );
}

export default WaterlowScoreList;


